(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-menu-nav-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var navs = document.querySelectorAll('[data-collection-nav]');
    if (!navs.length) return;

    function showSubRow(nav, catId) {
      var primaries = nav.querySelectorAll('.collection-nav__primary-link');
      var panels = nav.querySelectorAll('.collection-nav__scroll-wrap[data-nav-cat-panel]');
      var i;

      for (i = 0; i < primaries.length; i++) {
        primaries[i].classList.remove('collection-nav__primary-link--hover');
      }
      for (i = 0; i < panels.length; i++) {
        panels[i].hidden = true;
      }

      if (!catId) return;

      var primary = nav.querySelector('.collection-nav__primary-link[data-nav-cat="' + catId + '"]');
      var panel = nav.querySelector('.collection-nav__scroll-wrap[data-nav-cat-panel="' + catId + '"]');
      if (primary) primary.classList.add('collection-nav__primary-link--hover');
      if (panel) {
        panel.hidden = false;
        requestAnimationFrame(function () {
          updateScrollWrap(panel);
        });
      }
    }

    function updateScrollWrap(wrap) {
      var row = wrap.querySelector('.collection-nav__primary-row, .collection-nav__secondary-row');
      if (!row) return;

      var canScroll = row.scrollWidth > row.clientWidth + 2;
      var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;

      wrap.classList.toggle('collection-nav__scroll-wrap--scrollable', canScroll);
      wrap.classList.toggle('collection-nav__scroll-wrap--at-end', atEnd);
    }

    function initScrollHints(nav) {
      var wraps = nav.querySelectorAll('[data-scroll-row]');
      var w;

      for (w = 0; w < wraps.length; w++) {
        (function (wrap) {
          if (wrap.dataset.scrollInit === '1') {
            updateScrollWrap(wrap);
            return;
          }
          wrap.dataset.scrollInit = '1';

          var row = wrap.querySelector('.collection-nav__primary-row, .collection-nav__secondary-row');
          if (!row) return;

          row.addEventListener(
            'scroll',
            function () {
              updateScrollWrap(wrap);
            },
            { passive: true }
          );

          updateScrollWrap(wrap);
        })(wraps[w]);
      }
    }

    for (var n = 0; n < navs.length; n++) {
      (function (nav) {
        var pinned = nav.getAttribute('data-pinned-cat');
        if (pinned) showSubRow(nav, pinned);

        initScrollHints(nav);

        nav.addEventListener('mouseover', function (evt) {
          var primary = evt.target.closest('.collection-nav__primary-link');
          if (!primary || !nav.contains(primary)) return;
          var catId = primary.getAttribute('data-nav-cat');
          if (!catId) return;
          var panel = nav.querySelector('.collection-nav__scroll-wrap[data-nav-cat-panel="' + catId + '"]');
          if (!panel) return;
          showSubRow(nav, catId);
          updateScrollWrap(panel);
        });

        nav.addEventListener('mouseleave', function () {
          showSubRow(nav, pinned || '');
        });
      })(navs[n]);
    }

    window.addEventListener('resize', function () {
      var n;
      for (n = 0; n < navs.length; n++) {
        initScrollHints(navs[n]);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
